module.exports = __webpack_public_path__ + "img/sushi-icon.aee67dbf.svg";